import { Box, BoxProps } from '../../Box';

/**
 * "Group" component that lets children use container queries for styles.
 * Only used internally.
 * See: https://tamagui.dev/docs/intro/styles#group
 */
export const LayoutGroup = ({ children, ...props }: BoxProps) => {
  return (
    <Box group="formLayout" flexDirection="row" justifyContent="center" {...props}>
      <Box flexGrow={1} width="100%">
        {children}
      </Box>
    </Box>
  );
};
